import { dashboardPluginNavItems } from '../../plugins/registry';

export const dashboardNavItems = dashboardPluginNavItems;
